import { WrappedFormUtils } from '@ant-design/compatible/lib/form/Form';
import { TimedealWidgetDetailV2 } from '../../../../../types/widget';

type UseTimedealWidgetFormReturnType = {
  isUseCoupon?: boolean;
  handleToggleIsUseCoupon: (isActive: boolean) => void;
};

interface UseTimedealWidgetFormProps {
  form: WrappedFormUtils;
}

export const useTimedealWidgetForm = (props: UseTimedealWidgetFormProps): UseTimedealWidgetFormReturnType => {
  const { form } = props;

  const { isUseCoupon, widgetItemTimeDealList } = form.getFieldsValue([
    'isUseCoupon',
    'widgetItemTimeDealList',
  ]) as Pick<Partial<TimedealWidgetDetailV2>, 'isUseCoupon' | 'widgetItemTimeDealList'>;

  const handleToggleIsUseCoupon = (isActive: boolean): void => {
    if (!isActive && widgetItemTimeDealList && widgetItemTimeDealList.length > 0) {
      form.setFieldsValue({
        widgetItemTimeDealList: widgetItemTimeDealList.map((item) => {
          const { coupon, ...rest } = item;

          return rest;
        }),
      });
    }
  };

  return { isUseCoupon, handleToggleIsUseCoupon };
};
